import { useEffect, useState } from "react";
import { Search, X, ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { db } from "../lib/data";
export default function SearchOverlay({ open, onClose }) {
  const [q, setQ] = useState(""),
    [rows, setRows] = useState([]);
  useEffect(() => {
    if (open) {
      const t = setTimeout(
        () =>
          db
            .products({ q, status: "active", limit: 8 })
            .then(setRows)
            .catch(() => setRows([])),
        200,
      );
      return () => clearTimeout(t);
    }
  }, [q, open]);
  if (!open) return null;
  return (
    <div className="search-overlay">
      <div className="search-overlay-inner">
        <button onClick={onClose}>
          <X />
        </button>
        <div className="search-field">
          <Search />
          <input
            autoFocus
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Search products…"
          />
        </div>
        <div className="search-results">
          {rows.map((p) => (
            <Link key={p.id} to={`/shop/${p.slug}`} onClick={onClose}>
              <div>
                <b>{p.display_name || p.name}</b>
                <small>{p.sku}</small>
              </div>
              <ArrowUpRight size={15} />
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}